// Shared constants for appointment/treatment colors

export const TREATMENT_COLORS = [
    '#FF6B6B', '#4ECDC4', '#45B7D1', '#96CEB4', '#9B59B6',
    '#F7D794', '#FF7F50', '#26A69A', '#5C6BC0', '#FF8A65',
    '#81C784', '#7986CB', '#FFB74D', '#4DB6AC', '#64B5F6',
    '#A1887F', '#F06292', '#9575CD', '#4DD0E1', '#DCE775',
];
